import { FC } from "react";
import * as _ from "lodash";

import { Col, Row, Table, TableProps, Typography } from "@ctra/components";

import { ReferralEntity, ReferralType } from "@ctra/api";
import { Enterprise as Content, useTranslation } from "@ctra/i18n";

import { useCurrentUser } from "@auth";

const { Text } = Typography;
const { Column } = Table;

const {
  settings: {
    users: {
      table: { values: tableValues, columns: columnHeaderCopy }
    }
  }
} = Content;

/**
 * Table view of referrals
 * @param {React.PropsWithChildren<TableProps<ReferralEntity | UserEntity>>} props
 * @returns {JSX.Element}
 * @constructor
 */
export const FarmReferralTable: FC<TableProps<ReferralEntity>> = (props) => {
  const { t } = useTranslation();
  const { user: currentUser } = useCurrentUser();
  const isFarmer = !!currentUser.farmAccess?.farmId;

  const getPointerName = (entity: ReferralEntity) => {
    return isFarmer && entity.type === ReferralType.farmerToUser ? "sourceUser" : "targetUser";
  };

  return (
    <Table<ReferralEntity> {...props}>
      <Column<ReferralEntity>
        width="50%"
        title={t<string>(columnHeaderCopy.email)}
        dataIndex="email"
        key="email"
        sorter={(a, b) =>
          _.defaultTo(a[getPointerName(a)].email, "").localeCompare(
            _.defaultTo(b[getPointerName(b)].email, "")
          )
        }
        render={(value, entity) => {
          const user = entity[getPointerName(entity)];

          return _.trim(user.email);
        }}
      />
      <Column<ReferralEntity>
        width="50%"
        title={t<string>(columnHeaderCopy.invitation)}
        dataIndex="status"
        key="status"
        render={(value, entity) => {
          const user = entity[getPointerName(entity)];
          const received = currentUser.email === user.email;

          return (
            <Row justify="space-between">
              <Col>
                <Text>{t<string>(tableValues.status(value), { received })}</Text>
              </Col>
            </Row>
          );
        }}
      />
    </Table>
  );
};
